module.exports = __webpack_public_path__ + "static/media/filled_bar_M3.78d6df41.svg";